module.exports = __webpack_public_path__ + "static/img/c.f4f6677f.svg";